'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Timepicker = require('./Timepicker');

var _Timepicker2 = _interopRequireDefault(_Timepicker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

exports["default"] = _Timepicker2["default"];
module.exports = exports['default'];